/**
 * The two visual themes the app is served under, carried in the `/h/:theme`
 * URL segment. `beach` is the kids theme; despite the name, it is the one that
 * gets Tailwind's `dark` class (see `app.css`) because the original app used
 * `dark` as the kids selector and the brand tokens are keyed off it.
 */
export const APP_THEMES = ['ocean', 'beach'] as const;

export type AppTheme = (typeof APP_THEMES)[number];

/** The theme that maps to the `dark` (kids) token block. */
export const KIDS_THEME = 'beach';

/**
 * Reads the theme out of a pathname, e.g. `/h/beach/learn/topics` → `beach`.
 * Returns `null` for any path that is not under `/h/<known theme>`, which is
 * what the un-themed screens (`/`, `/start`, `/healthcheck`) hit.
 */
export function themeFromPathname(pathname: string): AppTheme | null {
  const [first, second] = pathname.split('/').filter(Boolean);

  if (first !== 'h') {
    return null;
  }

  return APP_THEMES.find((theme) => theme === second) ?? null;
}

/**
 * The class the document element carries for a theme. Only the kids theme adds
 * one; `ocean` and the un-themed screens use the `:root` tokens.
 */
export function themeClassName(theme: AppTheme | null): string | undefined {
  return theme === KIDS_THEME ? 'dark' : undefined;
}
